module.exports = __webpack_public_path__ + "static/media/nope-not-here.8156b689.webp";